var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	75435: () => (loadSingletonVersion("default", "react", true, [4,19,2,4], () => (() => (__webpack_require__(65043))))),
	88200: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [4,2,11,2], () => (Promise.all([__webpack_require__.e(2099), __webpack_require__.e(7827), __webpack_require__.e(673)]).then(() => (() => (__webpack_require__(70673))))))),
	36843: () => (loadSingletonVersion("default", "react-redux", false, [4,9,2,0], () => (__webpack_require__.e(3003).then(() => (() => (__webpack_require__(83003))))))),
	49262: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-constants", false, [4,0,1,71], () => (__webpack_require__.e(6588).then(() => (() => (__webpack_require__(26588))))))),
	84290: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-web-trading", false, [4,2,0,49], () => (__webpack_require__.e(3710).then(() => (() => (__webpack_require__(63710))))))),
	30506: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,10,9], () => (Promise.all([__webpack_require__.e(838), __webpack_require__.e(552), __webpack_require__.e(6803), __webpack_require__.e(9262), __webpack_require__.e(4290), __webpack_require__.e(876)]).then(() => (() => (__webpack_require__(76803))))))),
	72144: () => (loadSingletonVersion("default", "dayjs", false, [4,1,11,19], () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))))),
	92684: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-market-data-ws", false, [4,1,0,11], () => (__webpack_require__.e(8566).then(() => (() => (__webpack_require__(88566))))))),
	26363: () => (loadSingletonVersion("default", "stylis", false, [4,4,3,6], () => (__webpack_require__.e(8312).then(() => (() => (__webpack_require__(98312))))))),
	10802: () => (loadSingletonVersion("default", "react-dom", false, [4,19,2,4], () => (__webpack_require__.e(5569).then(() => (() => (__webpack_require__(97950))))))),
	73462: () => (loadSingletonVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(1880).then(() => (() => (__webpack_require__(1880))))))),
	10649: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-instruments", false, [4,1,2,43], () => (Promise.all([__webpack_require__.e(105), __webpack_require__.e(9262), __webpack_require__.e(2144), __webpack_require__.e(8606)]).then(() => (() => (__webpack_require__(105))))))),
	58726: () => (loadSingletonVersion("default", "styled-components", false, [4,6,3,12], () => (__webpack_require__.e(3354).then(() => (() => (__webpack_require__(53354))))))),
	42856: () => (loadSingletonVersion("default", "react-router", false, [4,7,13,1], () => (__webpack_require__.e(9543).then(() => (() => (__webpack_require__(79543))))))),
	33000: () => (loadSingletonVersion("default", "i18next", false, [4,25,8,14], () => (__webpack_require__.e(4978).then(() => (() => (__webpack_require__(44978))))))),
	4197: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-marketdata", false, [4,1,1,42], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(7171), __webpack_require__.e(9262), __webpack_require__.e(4290), __webpack_require__.e(2684)]).then(() => (() => (__webpack_require__(37171))))))),
	3289: () => (loadSingletonVersion("default", "react-device-detect", false, [4,2,2,3], () => (__webpack_require__.e(8738).then(() => (() => (__webpack_require__(8738))))))),
	4542: () => (loadSingletonVersion("default", "@grafana/faro-react", false, [1,2,2,4], () => (__webpack_require__.e(2049).then(() => (() => (__webpack_require__(32049))))))),
	8593: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-watchlists", false, [4,1,3,48], () => (__webpack_require__.e(9707).then(() => (() => (__webpack_require__(99707))))))),
	22746: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-orders", false, [4,1,0,13], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(3820)]).then(() => (() => (__webpack_require__(63820))))))),
	23592: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-subscriptions", false, [4,0,1,0], () => (Promise.all([__webpack_require__.e(2282), __webpack_require__.e(6186)]).then(() => (() => (__webpack_require__(83805))))))),
	44800: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-frontend-hooks", false, [4,1,0,28], () => (__webpack_require__.e(231).then(() => (() => (__webpack_require__(72612))))))),
	56167: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-charts", false, [4,1,6,29], () => (__webpack_require__.e(2128).then(() => (() => (__webpack_require__(62128))))))),
	56419: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-module", false, [4,1,2,16], () => (__webpack_require__.e(3148).then(() => (() => (__webpack_require__(50767))))))),
	62707: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-client", false, [4,1,9,42], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(9266), __webpack_require__.e(6626)]).then(() => (() => (__webpack_require__(19266))))))),
	67310: () => (loadSingletonVersion("default", "@grafana/faro-web-tracing", false, [1,2,2,4], () => (__webpack_require__.e(5295).then(() => (() => (__webpack_require__(75295))))))),
	68841: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-messages", false, [4,1,0,16], () => (__webpack_require__.e(4020).then(() => (() => (__webpack_require__(1639))))))),
	71475: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-analytics", false, [4,2,1,34], () => (Promise.all([__webpack_require__.e(3307), __webpack_require__.e(1780)]).then(() => (() => (__webpack_require__(93307))))))),
	73119: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-accounts", false, [4,2,1,34], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(3731)]).then(() => (() => (__webpack_require__(43731))))))),
	77275: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-account-management", false, [4,0,0,4], () => (__webpack_require__.e(7196).then(() => (() => (__webpack_require__(7196))))))),
	82932: () => (loadSingletonVersion("default", "usehooks-ts", false, [4,3,1,1], () => (__webpack_require__.e(6864).then(() => (() => (__webpack_require__(54483))))))),
	83067: () => (loadSingletonVersion("default", "i18next-xhr-backend", false, [4,3,2,2], () => (__webpack_require__.e(3548).then(() => (() => (__webpack_require__(1167))))))),
	85173: () => (loadSingletonVersion("default", "react-i18next", false, [4,16,5,5], () => (__webpack_require__.e(6930).then(() => (() => (__webpack_require__(76930))))))),
	85484: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-exchange", false, [4,1,7,9], () => (Promise.all([__webpack_require__.e(838), __webpack_require__.e(7236), __webpack_require__.e(876)]).then(() => (() => (__webpack_require__(37236))))))),
	99467: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-design-system", false, [4,0,88,4], () => (Promise.all([__webpack_require__.e(2099), __webpack_require__.e(2594), __webpack_require__.e(4499), __webpack_require__.e(6600), __webpack_require__.e(2008)]).then(() => (() => (__webpack_require__(4499))))))),
	71780: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,10,9], () => (Promise.all([__webpack_require__.e(838), __webpack_require__.e(552), __webpack_require__.e(1793), __webpack_require__.e(8200), __webpack_require__.e(6843), __webpack_require__.e(4290), __webpack_require__.e(876)]).then(() => (() => (__webpack_require__(11793))))))),
	57282: () => (loadSingletonVersion("default", "react-select", false, [4,5,10,2], () => (__webpack_require__.e(2364).then(() => (() => (__webpack_require__(2364))))))),
	71639: () => (loadSingletonVersion("default", "smooth-scroll-into-view-if-needed", false, [4,2,0,2], () => (__webpack_require__.e(1940).then(() => (() => (__webpack_require__(91940))))))),
	90698: () => (loadSingletonVersion("default", "dayjs", false, [4,1,11,19], () => (__webpack_require__.e(9280).then(() => (() => (__webpack_require__(39280))))))),
	96748: () => (loadSingletonVersion("default", "lodash.merge", false, [4,4,6,2], () => (__webpack_require__.e(6819).then(() => (() => (__webpack_require__(16819))))))),
	26626: () => (loadSingletonVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(435).then(() => (() => (__webpack_require__(10435))))))),
	20876: () => (loadSingletonVersion("default", "@forgerock/javascript-sdk", false, [4,4,8,3], () => (Promise.all([__webpack_require__.e(2099), __webpack_require__.e(7827), __webpack_require__.e(2202)]).then(() => (() => (__webpack_require__(22202))))))),
	68606: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-web-trading", false, [4,2,0,49], () => (__webpack_require__.e(3902).then(() => (() => (__webpack_require__(83902))))))),
	2282: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,10,9], () => (Promise.all([__webpack_require__.e(838), __webpack_require__.e(552), __webpack_require__.e(8447), __webpack_require__.e(9262), __webpack_require__.e(4290), __webpack_require__.e(876)]).then(() => (() => (__webpack_require__(78447)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"506": [
		30506
	],
	"649": [
		10649
	],
	"802": [
		10802
	],
	"876": [
		20876
	],
	"1780": [
		71780
	],
	"2144": [
		72144
	],
	"2282": [
		2282
	],
	"2545": [
		3289,
		4542,
		8593,
		22746,
		23592,
		44800,
		56167,
		56419,
		62707,
		67310,
		68841,
		71475,
		73119,
		77275,
		82932,
		83067,
		85173,
		85484,
		99467
	],
	"2684": [
		92684
	],
	"2856": [
		42856
	],
	"3000": [
		33000
	],
	"3462": [
		73462
	],
	"4197": [
		4197
	],
	"4290": [
		84290
	],
	"5435": [
		75435
	],
	"6363": [
		26363
	],
	"6600": [
		57282,
		71639,
		90698,
		96748
	],
	"6626": [
		26626
	],
	"6843": [
		36843
	],
	"8200": [
		88200
	],
	"8606": [
		68606
	],
	"8726": [
		58726
	],
	"9262": [
		49262
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}